module.exports = __webpack_public_path__ + "img/video_min.b2d4c5fc.png";